export default __webpack_public_path__ + "static/everett-light-webfont-d2b4816d9523a789079f51c5ee9a14ec.woff2";